import { useState } from "react";
import api, { formatApiErrorDetail } from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger,
} from "./ui/dialog";
import { Mail, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

export const WaitlistDialog = ({ children, source = "website" }) => {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post("/waitlist", { email, name, source });
      setDone(true);
      toast.success(res.data.message);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const reset = (v) => {
    setOpen(v);
    if (!v) {
      setTimeout(() => { setDone(false); setEmail(""); setName(""); }, 200);
    }
  };

  return (
    <Dialog open={open} onOpenChange={reset}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="bg-ivory border-gold/40 max-w-md">
        {done ? (
          <div className="text-center py-6" data-testid="waitlist-success">
            <CheckCircle2 className="w-14 h-14 text-forest mx-auto" strokeWidth={1.5} />
            <h2 className="font-serif text-3xl text-forest mt-5">You're on the list!</h2>
            <p className="text-charcoal/70 mt-3">
              Thank you for joining the community. We'll be in touch with wisdom, tools,
              and the moment new releases go live.
            </p>
            <Button onClick={() => reset(false)} className="rounded-full bg-forest hover:bg-forest-light text-ivory px-8 h-11 mt-7" data-testid="waitlist-close-btn">
              Wonderful
            </Button>
          </div>
        ) : (
          <>
            <DialogHeader>
              <div className="w-12 h-12 rounded-full bg-gold/20 flex items-center justify-center mb-2">
                <Mail className="w-6 h-6 text-gold" />
              </div>
              <DialogTitle className="font-serif text-3xl text-forest">Join the Community</DialogTitle>
              <DialogDescription className="text-charcoal/60">
                Be the first to know about new books, tools, and the launch of Welcome to Adulthood.
                No spam — just encouragement and updates.
              </DialogDescription>
            </DialogHeader>
            <form onSubmit={submit} className="space-y-4 mt-2">
              <Input
                placeholder="Your name (optional)"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="rounded-xl border-gold/40 focus-visible:ring-gold bg-white"
                data-testid="waitlist-name"
              />
              <Input
                type="email"
                required
                placeholder="you@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="rounded-xl border-gold/40 focus-visible:ring-gold bg-white"
                data-testid="waitlist-email"
              />
              <Button type="submit" disabled={loading} className="w-full rounded-full bg-forest hover:bg-forest-light text-ivory h-12 transition-colors" data-testid="waitlist-submit">
                {loading ? "Joining…" : "Join the Community"}
              </Button>
            </form>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};
